import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HomeDelivery = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "home-delivery-icon"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_2847_1753)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.998 10.5197L17.4424 0.122803L1.53718 10.4958C1.07458 10.7975 0.944143 11.4171 1.24584 11.8797C1.54753 12.3423 2.16712 12.4727 2.62972 12.171L17.3911 2.54399L27.0833 9.46698V30.0001H4.75C4.19772 30.0001 3.75 30.4478 3.75 31.0001C3.75 31.5524 4.19772 32.0001 4.75 32.0001H28.0833C28.6356 32.0001 29.0833 31.5524 29.0833 31.0001V10.8955L30.8355 12.1471C31.285 12.4681 31.9095 12.364 32.2305 11.9146C32.5515 11.4652 32.4474 10.8407 31.998 10.5197ZM17.7197 16.5832C16.75 15.0555 13.8409 12.0001 9.96212 12.0001C6.08333 12.0001 3.49748 14.1143 2.68939 15.642C2.55859 16.4369 2.15999 17.2357 1.76019 18.0369C1.30331 18.9525 0.844859 19.8712 0.782643 20.7908C0.75 21.2733 0.75 21.795 0.75 22.3121C0.75 23.5883 1.21995 24.3833 1.66911 24.813C1.96105 25.0923 2.36029 25.1665 2.75506 25.1756C3.30391 26.8211 4.7858 28.0001 6.52778 28.0001C7.91653 28.0001 9.13998 27.2507 9.85714 26.1131C9.94155 25.9792 10.019 25.8399 10.0888 25.6958C10.1697 25.5288 10.2404 25.3555 10.3002 25.1766H11.6443C11.704 25.3555 11.7747 25.5288 11.8557 25.6958C11.9255 25.8399 12.0029 25.9792 12.0873 26.1131C12.8045 27.2507 14.0279 28.0001 15.4167 28.0001C17.1583 28.0001 18.6399 26.8215 19.1891 25.1766H19.2191C19.8256 25.1766 20.4408 25.0298 20.8765 24.5831C21.4697 23.9752 22.0833 23.0022 22.0833 21.7392C22.0833 19.4477 22.0833 17.6471 17.7197 16.5832ZM4.57993 16.3765C4.35457 17.3206 3.91833 18.1928 3.59942 18.8305L3.54975 18.9299C3.04561 19.9402 2.80805 20.4829 2.77808 20.9258C2.75084 21.3285 2.75 21.78 2.75 22.3121C2.75 22.7465 2.83747 23.0188 2.91921 23.1788L4.20721 23.2083L4.6523 24.5427C4.95704 25.4564 5.7325 26.0001 6.52778 26.0001C7.3229 26.0001 8.0982 25.4566 8.40308 24.5433L8.85931 23.1766H13.0851L13.5414 24.5433C13.8462 25.4566 14.6215 26.0001 15.4167 26.0001C16.2118 26.0001 16.9871 25.4566 17.292 24.5433L17.7482 23.1766H19.2191C19.3545 23.1766 19.4388 23.161 19.4806 23.1492C19.8185 22.7891 20.0833 22.3043 20.0833 21.7392C20.0833 20.4605 20.0289 20.059 19.8436 19.7636C19.7103 19.551 19.24 19.0125 17.2459 18.5263L16.463 18.3354L16.0311 17.655C15.6771 17.0972 14.8821 16.1431 13.7674 15.3448C12.6621 14.5533 11.3649 14.0001 9.96212 14.0001C7.01828 14.0001 5.18675 15.492 4.57993 16.3765Z",
                    fill: "url(#paint0_linear_2847_1753)"
                })
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_2847_1753",
                        x1: "0.75",
                        y1: "0.122803",
                        x2: "32.6266",
                        y2: "31.789",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_2847_1753",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.75)"
                        })
                    })
                ]
            })
        ]
    });
